import React from 'react';
import { useTranslation } from 'react-i18next';

import { isDelawareJurisdiction } from '../../../../../utils/jurisdiction';

export const ShareCapitalCard: React.FC<any> = ({ companyInfo }) => {
  const { t } = useTranslation();
  const isDelaware = isDelawareJurisdiction(companyInfo?.jurisdiction);

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
      <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
        <div className="mb-2 flex items-center justify-between">
          <span className="text-sm font-medium text-gray-600">
            {isDelaware ? t('others.othTotalAuthorizedUnits') : t('others.othTotalAuthorizedShares')}
          </span>
        </div>
        <p className="text-lg font-semibold text-gray-800">
          {companyInfo?.total_authorized_shares?.toLocaleString() || (
            <span className="font-normal text-gray-400">{t('labels.lblNoDataAvailable') || 'Não definido'}</span>
          )}
        </p>
      </div>

      <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
        <div className="mb-2 flex items-center justify-between">
          <span className="text-sm font-medium text-gray-600">{t('others.othParValue')}</span>
        </div>
        <p className="text-lg font-semibold text-gray-800">
          {companyInfo?.par_value?.toLocaleString() || (
            <span className="font-normal text-gray-400">{t('labels.lblNoDataAvailable') || 'Não definido'}</span>
          )}
        </p>
      </div>

      <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
        <div className="mb-2 flex items-center justify-between">
          <span className="text-sm font-medium text-gray-600">
            {isDelaware ? t('others.othTotalIssuedUnits') : t('others.othTotalIssuedShares')}
          </span>
        </div>
        <p className="text-lg font-semibold text-gray-800">
          {companyInfo?.total_issued_shares?.toLocaleString() || (
            <span className="font-normal text-gray-400">{t('labels.lblNoDataAvailable') || 'Não definido'}</span>
          )}
        </p>
      </div>
    </div>
  );
};
